import { UpdatingElement } from 'lit-element'

class SbtMapGeojson extends UpdatingElement {

  static get is() { return 'sbt-map-geojson'}

  static get properties() {
     return {

      sourceId: {
        type: String,
        attribute: 'source-id'
      },

      sourceData: {
        type: Object,
        attribute: 'source-data'
      },

      sourceUrl: {
        type: String,
        attribute: 'source-url'
      },

      maxZoom: {
        type: Number,
        attribute: 'max-zoom'
      },

      buffer: {
        type: Number
      },

      tolerance: {
        type: Number
      },

      cluster: {
        type: Boolean
      },

      clusterRadius: {
        type: Number,
        attribute: 'cluster-radius'
      },

      clusterMaxZoom: {
        type: Number,
        attribute: 'cluster-max-zoom'
      },

    }
  }

  set map(map) {
    if (map !== this._map) {
      // this._map && this.removeSource()
      this._map = map

      if (typeof this.data === 'object') {
        map && this.initSource()
        return
      }

      const geojsonData = this.loadGeojson(this.data)
        .then((result) => {
          this.data = result
          map && this.initSource()
          return
        })
    }
  }

  get map() {
    return this._map
  }

  set sourceData(sourceData) {
    this.source && this.source.setData(sourceData)
    this.data = sourceData
  }

  get sourceData() {
    return typeof this.data === 'object' ? this.data : null
  }

  set sourceUrl(sourceUrl) {
    this.source && this.source.setData(sourceUrl)
    this.data = sourceUrl
  }

  get sourceUrl() {
    return typeof this.data === 'string' ? this.data : null
  }

  get clusterConf() {
    if (this.cluster) {
      return {
        cluster: true,
        clusterRadius: this.clusterRadius,
        clusterMaxZoom: this.clusterMaxZoom || this.maxZoom - 1
      }
    }
    return {}
  }

  constructor(props) {
    super(props)
    this.maxZoom = 18
    this.buffer = 128
    this.tolerance = 0.375
    this.clusterRadius = 50
    this.clusterMaxZoom = null
    this._map = null
    this.source = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.map && this.removeSource()
  }

  /**
   * Initialize the geojson's source
   * the "this.data" property needs to be geojson data
   */
  initSource() {
    if (!this.map.isStyleLoaded()) {
      // return this.map.once('load', this.initSource.bind(this))
    }

    this.map.addSource(
      this.sourceId,
      {
        type: 'geojson',
        data: this.data,
        maxzoom: this.maxZoom,
        buffer: this.buffer,
        tolerance: this.tolerance,
        ...this.clusterConf
      }
    )
    this.source = this.map.getSource(this.sourceId)
  }

  /**
   * Remove source from the element
   */
  removeSource() {
    this.map.removeSource(this.sourceId)
  }

  /**
   * Load geojson data from an endpoint
   * and return a valid geojson object
   */
  loadGeojson(endpointUrl) {
    let geojson = { "type": "FeatureCollection", "features": [] }

    if (typeof endpointUrl !== 'string' || endpointUrl === '') {
      console.warn("Invalid endpoint address for the geojson element")
      return
    }

    return fetch(endpointUrl, {cache: 'reload'})
      .then(response => {
        return response.json()
      })
      .then(mapJSON => {
        geojson.features = mapJSON
        return geojson
      })
      .catch(error => {
        throw new Error(error)
      })
  }
}

customElements.define(SbtMapGeojson.is, SbtMapGeojson)
